import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedRoute({ element, requiredRole = 'admin' }) {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  
  if (!token || !userStr) {
    return <Navigate to="/admin/login" replace />;
  }

  try {
    const user = JSON.parse(userStr);
    if (requiredRole && user.role !== requiredRole && user.role !== 'admin') {
      return (
        <div style={{ padding: '40px 20px', textAlign: 'center', minHeight: '60vh' }}>
          <h1>Access Denied</h1>
          <p>This page is currently only available for administrators.</p>
          <p>Please check back soon!</p>
        </div>
      );
    }
    return element;
  } catch (error) {
    return <Navigate to="/admin/login" replace />;
  }
}

export default ProtectedRoute;
